

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.SdPd1zq-.js","_app/immutable/chunks/CWj6FrbW.js","_app/immutable/chunks/DFtyeP3E.js","_app/immutable/chunks/CtZl-tYg.js","_app/immutable/chunks/SjIGePN-.js","_app/immutable/chunks/DXK7xvw7.js"];
export const stylesheets = [];
export const fonts = [];
